export const doxNegotiatedDiscountsFilterState = () => ({
  searchKey: "",
  stationTypes: {
    value: ["DODOX", "WIDOX"],
    isAll: true,
  },
  page: 1,
  perPage: 10,
});